import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { createStructuredSelector } from "reselect"

import { Icon } from 'elements'
import { withClientId } from "hocs"
import { wsClient } from "index"
import { withRouter } from 'react-router-dom'
import { listHolderSchedules, listSchedules } from "redux/modules/model/attendance"
import { holderSchedulesSelector, schedulesSelector } from "redux/selectors"
import { bem } from "utils/helpers"

import { Table } from 'elements'

import "./index.scss"

const em = (e, m) => bem("contact-schedule-assignments", e, m)

const columns = [
  {
    title: "ID",
    dataIndex: "scheduleId",
    key: "scheduleId",
    render: (data) => (<code>{data}</code>),
    sorter: (a, b) => a.scheduleId.localeCompare(b.scheduleId)
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (data) => (data),
    sorter: (a, b) => a.name.localeCompare(b.name)
  },
  {
    title: "Attendance",
    dataIndex: "attendancePercent",
    key: "attendancePercent",
    render: (data) => (data === null ? "---" : `${data}%`),
    sorter: (a, b) => a.attendancePercent - b.attendancePercent
  }
]

class ContactScheduleAssignments extends Component {

  constructor (props) {
    super(props)
    this.state = {
      holderScheduleAttendanceBySchedule: {},
      list: [],
      loading: false,
    }
  }

  componentDidMount = () => {
    this.getHoldersList()
  }

  componentWillUnmount(){
    // this.clearSubs()
  }

  // clearSubs = () => {
  //   wsClient.clearAllCorrelations(
  //     'attendance.schedule.report-schedule-attendance',
  //   );
  // };
  getHoldersList = () => {
    this.setState({loading: true})
    const { clientId, match } = this.props
    const { clientReference } = match.params

    const requestPayload = {
      messageType: 'attendance.schedule.report-schedule-attendance',
      payload: {
        clientId,
        clientReference,
      },
    };

    wsClient.request(requestPayload, response => {
      const { payload } = response;
      if (payload && Array.isArray(payload)) {
        this.setState({
          list: payload,
          loading: false
        });
      }
    });
  };

  render = () => {
    const { edit, removeCallback, removeQueue } = this.props
    const { list, loading } = this.state
    const dataSource = list && list.length ?list.map(el=>({
      scheduleId: el.scheduleId,
      name: el.scheduleName,
      attendancePercent: el.attendancePercentage
    })): null
    return edit
      ? dataSource &&
      dataSource.map((schedule) => {
          const queuedForDeletion = Boolean(removeQueue) &&
            Boolean(removeQueue.find((scheduleId) => (
              scheduleId === schedule.scheduleId
            )))
          return <p key={schedule.scheduleId} className={em("schedule-item")} style={queuedForDeletion ? {opacity: 0.35} : null}>
            <span className={em("schedule-id")}>{schedule.scheduleId}</span>
            <span className={em("schedule-name")}>{schedule.name}</span>
            {! queuedForDeletion &&
              <button type="button" className={em("schedule-action")}
                  onClick={() => {
                    const scheduleId = schedule.scheduleId
                    removeCallback(scheduleId)
                  }}
              >
                <Icon type="minus-circle-o" /> Remove
              </button>
            }
          </p>
        })
      : <Table dataSource={dataSource} loading={loading} columns={columns} pagination={false} rowKey="scheduleId" />
  }

}

export const selectors = createStructuredSelector({
  holderSchedules: holderSchedulesSelector,
  schedules: schedulesSelector
})
export const actions = {
  listHolderSchedules,
  listSchedules
}
export default compose(
  withClientId,
  withRouter,
  connect(selectors, actions),
)(ContactScheduleAssignments)



// WEBPACK FOOTER //
// ./src/pages/directory/contact-details/components/attendance/contact-schedule-assignments/index.js